export default __webpack_public_path__ + "static/media/empty.ad942a5b.svg";